import React from 'react';
import { useAuth } from '../auth/AuthProvider';
import { AzureFunctionCall } from './AzureFunctionCall';

export const MainApp: React.FC = () => {
  const { account } = useAuth();

  return (
    <div>
      <header style={{ padding: '20px', borderBottom: '1px solid #ccc' }}>
        <h1>Internal Harri Pay Data Sheet Generator</h1>
        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '15px' }}>
          <span>Currently signed in user: <b>{account?.name || account?.username}</b></span>
          <img src="/images/happyStarGlasses.PNG" alt="Happy Star with Glasses" style={{ height: '150px' }} />
        </div>
      </header>
      <main style={{ padding: '20px' }}>
        <AzureFunctionCall />
      </main>
    </div>
  );
};